<template>
    <div>
    <div v-if="contract_url" style="">
      <iframe :width="iframe_width" :height="iframe_height" :src=this.contract_url ref="iframe" id="iframe" frameborder="0" scrolling="yes" style="-webkit-overflow-scrolling: touch;"></iframe>
    </div>
    <div v-if="!finished" id="bank_verification_in_progress">
        <h3 style="margin-top: 30px">Contract Generation in Progress</h3>
        <p>
          Please do not close this page while we generate the contract.
          This should only take a few (minutes/seconds).
        </p>
        <div class="buttons is-right">
          <a
            class="button is-link padded-button next-button is-loading"
            >Continue</a
          >
        </div>
    </div>
</div>
</template>

<script>
import MyUtils from "@/utils/MyUtils";

import $ from "jquery";
export default {
  name: "AffiliatesGenerate",
  components: {
  },
  props: {
    link: String,
  },
  data() {
    return {
        contract_url: '',
        iframe_width : 0,
        iframe_height: 0,
        finished: false,
        should_refresh: true,
   };
  },
    mounted: function () {
      this.iframe_width = "100%";
      this.iframe_height = "95vh";
      this.checkCampaignComplete();
    },
    methods :{
        isMobile: function () {
            return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        pandadoc_events: function(){
          let self = this;
          window.addEventListener('message', (event) => {
            const type = event.data && event.data.type;
            const payload = event.data && event.data.payload;
            console.log('type: ');
            console.log(type);
            switch (type) {
              case 'session_view.document.loaded':
                console.log('Session view is loaded');
                if (self.isMobile()) {
                  $("#iframe").css('height','80vh');
                }else{
                  $("#iframe").css('height','95vh');
                }
                
                break;
              case 'session_view.document.completed':
                console.log('Document is completed');
                console.log(payload);
                window.location.replace('https://getfunded.cardiff.co/affiliate-sign-up-success');
                break;
              case 'session_view.document.exception':
                console.log('Exception during document finalization');
                console.log(payload);
            }
          });
        },
        checkCampaignComplete: function(){
      console.log('checkServerStatus');
      const interval = 2000; // seconds
      var self = this;
      async function fetchUpdates() {
        try {
          console.log('fetch Updates');
            // Call the user-defined validation function to check if polling should stop
              console.log("Stopping polling as the condition is met.");
              self.should_refresh = false; // Stop polling
              let campaign_mem = MyUtils.getWithExpiry('campaign_id');
              console.log('campaign mem');
              console.log(campaign_mem);
              if(campaign_mem){
                self.should_refresh = false;
                let campaign_id = null;
                let campaign_mem = MyUtils.getWithExpiry('campaign_id');
                if(campaign_mem){
                    campaign_id = campaign_mem;
                }
                let final_email = self.link;
                let email_mem = MyUtils.getWithExpiry('email');
                if(email_mem){
                  final_email = email_mem;
                }
                $.ajax({
                  type: "POST",
                  url: "/api/affiliate/generate_contract",
                  contentType: "application/json",
                  dataType: "json",
                  data: JSON.stringify({
                    email: final_email,
                    campaign_id : campaign_id
                  }),
                })
                .done(function (response) {
                    self.finished = true;
                    self.contract_url = response.URL;
                    self.pandadoc_events();
                    setTimeout(function(){
                      $("#app-column-affiliate-contract").css('width','100%');
                      $("#app-column-affiliate-contract").css('height','95vh');
                      $("#app-column-affiliate-contract").css('max-width','100%');
                      $("#app-column-affiliate-contract").css('padding','0%');
                    },3000);
                })
                .fail(function (err) {
                    console.log(err.responseText);
                });
                return;
              }
          
            console.log("Continuing to poll, no campaign");
        } catch (error) {
            console.error("Error fetching updates:", error);
        }
        // Schedule the next polling if not stopped
        if (self.should_refresh) {
            setTimeout(fetchUpdates, interval);
        }
      }
      fetchUpdates();
    },
    }
};
</script>
<style scoped> 
iframe {
    width: 100%;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
}
</style>